import api from '@/lib/api';

export interface PropertyQuery {
  /** Free-text search over name / city / country (server-side ILIKE). */
  q?: string;
  city?: string;
  page?: number;
  limit?: number;
}

/** Shape returned by the paginated GET /properties (data + meta). */
export interface PropertyListMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface PropertyListResponse<T = Record<string, unknown>> {
  data: T[];
  meta: PropertyListMeta;
}

export interface CreatePropertyPayload {
  name: string;
  city: string;
  address: string;
  country: string;
  ownerId: string;
  description?: string;
}

export interface CreateUnitPayload {
  name: string;
  type: string;
  capacity: number;
  basePrice: number;
  weekendPrice?: number;
}

export async function fetchProperties(query?: PropertyQuery) {
  const { data } = await api.get('/properties', { params: query });
  return data;
}

export async function fetchProperty(id: string) {
  const { data } = await api.get(`/properties/${id}`);
  return data;
}

export async function fetchUnits(propertyId: string) {
  const { data } = await api.get(`/properties/${propertyId}/units`);
  return data;
}

export async function createProperty(payload: CreatePropertyPayload) {
  const { data } = await api.post('/properties', payload);
  return data;
}

export interface UpdatePropertyPayload {
  name?: string;
  city?: string;
  address?: string;
  country?: string;
  description?: string;
}

export interface UpdateUnitPayload {
  name?: string;
  type?: string;
  capacity?: number;
  basePrice?: number;
  weekendPrice?: number;
  isActive?: boolean;
}

export async function createUnit(propertyId: string, payload: CreateUnitPayload) {
  const { data } = await api.post(`/properties/${propertyId}/units`, payload);
  return data;
}

export async function updateProperty(id: string, payload: UpdatePropertyPayload) {
  const { data } = await api.patch(`/properties/${id}`, payload);
  return data;
}

export async function deleteProperty(id: string): Promise<void> {
  await api.delete(`/properties/${id}`);
}

export async function updateUnit(propertyId: string, unitId: string, payload: UpdateUnitPayload) {
  const { data } = await api.patch(`/properties/${propertyId}/units/${unitId}`, payload);
  return data;
}

export async function deleteUnit(propertyId: string, unitId: string): Promise<void> {
  await api.delete(`/properties/${propertyId}/units/${unitId}`);
}
